// components/TotalSalesMonthDisplay.jsx
import { Typography, Paper } from "@mui/material";

export default function AverageCountSales30DaysDisplay({ total }) {
  return (
    <Paper
      elevation={3}
      sx={{
        p: 1,
        my: 1,
        width: "30%",
        height: "14vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 2,
        backgroundColor: "#2d8bba",
        textAlign: "center",
        boxShadow: "5px 5px 15px rgba(0,0,0,0.2)"
      }}
    >
      <Typography variant="body2" color="white">
        Cantidad de Clientes Diarios (Promedio últimos 30 Días)
      </Typography>
      <Typography variant="h5" color="white" sx={{ mt: 1 }}>
        {total !== null ? total : "Cargando..."}
      </Typography>
    </Paper>
  );
}
